// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"page_contactForm__fmHM1","contactTable":"page_contactTable__aRvZQ"};